import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackreact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6.54626 12.2929L12.132 17.8787C12.5226 18.2692 12.5226 18.9024 12.132 19.2929C11.7415 19.6834 11.1084 19.6834 10.7178 19.2929L4.19952 12.7746C3.93349 12.5086 3.93349 12.0772 4.19952 11.8112L10.7178 5.29289C11.1084 4.90237 11.7415 4.90237 12.132 5.29289C12.5226 5.68342 12.5226 6.31658 12.132 6.70711L6.54626 12.2929Z" }), /* @__PURE__ */ _jsx("path", { d: "M5.42497 13.2928H19.2593C19.8116 13.2928 20.2593 12.8451 20.2593 12.2928C20.2593 11.7405 19.8116 11.2928 19.2593 11.2928H5.42497V13.2928Z" })]
});
export default SvgBackreact;
